// extracted by mini-css-extract-plugin
export var compact = "_ps-2";
export var phoneFrame = "_ps-0";
export var phoneScreen = "_ps-1";